<template>
  <div class="px-3 pb-2">
    <div class="row">
      <div class="col-sm-12">
        <div :class="['card', { 'border-info': show }]">
          <div
            class="card-header d-flex justify-content-between align-items-center position-relative"
            @click="show = !show"
          >
            <h5>
              {{ $t('activity.activity') }}: <strong>{{ group.date | dayAndDate }}</strong>
            </h5>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center">
                <span class="mb-0">{{ $t('activity.timeActiveTotal') }}:</span>
                <strong class="block text-right ml-2 mb-0">{{ calculateTotalTime }}</strong>
                <small
                  class="form-text text-right text-muted ml-2 mt-0 position-absolute"
                  style="font-size: 13px; bottom: 5px; right: 4em;"
                  >h:mm:ss</small
                >
                <!-- <strong>{{ activity.time_active | elapsedSecondsInHours }}</strong> -->
              </div>
              <div class="ml-2">
                <i :class="['fa', { 'fa-chevron-up': show }, { 'fa-chevron-down': !show }, 'show']"></i>
              </div>
            </div>
          </div>
          <transition name="component-fade" mode="out-in">
            <div v-if="show" class="card-body">
              <!-- <ul class="list-group list-group-horizontal">
                  <li class="list-group-item">
                    <span>{{ $t('activity.grade') }}:</span>
                    <strong>{{ item.grade_name }}</strong>
                  </li>
                  <li class="list-group-item">
                    <span>{{ $t('activity.subject') }}:</span>
                    <strong>{{ item.subject_name | deleteNumbers }}</strong>
                  </li>
                  <li class="list-group-item">
                    <span>{{ $t('activity.cluster') }}:</span>
                    <strong>{{ item.cluster_name }}</strong>
                  </li>
                  <li class="list-group-item">
                    <span>{{ $t('activity.lessonName') }}:</span>
                    <strong>{{ item.lesson_name }}</strong>
                  </li>
                  <li class="list-group-item">
                    <span>{{ $t('activity.lessonQuizPresented') }}:</span>
                    <strong>{{ item.quiz_presented }}</strong>
                  </li>
                </ul> -->
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">{{ $t('activity.grade') }}</th>
                      <th scope="col">{{ $t('activity.subject') }}</th>
                      <th scope="col">{{ $t('activity.cluster') }}</th>
                      <th scope="col">{{ $t('activity.lessonName') }}</th>
                      <th scope="col">{{ $t('activity.lessonTimeActive') }}</th>
                      <th scope="col">{{ $t('activity.lessonQuizPresented') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in group.items" :key="item.grade_name + index">
                      <th scope="row">{{ index + 1 }}</th>
                      <td>{{ item.grade_name }}</td>
                      <td>{{ item.subject_name | deleteNumbers }}</td>
                      <td>{{ item.cluster_name }}</td>
                      <td>{{ item.lesson_name }}</td>
                      <td>{{ calculateTime(item.start_date, item.end_date) }}</td>
                      <td>
                        <div v-if="item.quiz_presented" class="d-flex align-items-center">
                          <i class="fa fa-check text-success mr-1"></i>
                          <div>
                            <span class="d-block">
                              {{ $t('activity.lessonAverageScore') }} : {{ item.quiz_score_latest }}
                            </span>
                            <!-- <span>
                              {{ $t('activity.lessonTimeActive') }} :
                              {{ calculateTime(item.start_date, item.end_date) }}
                            </span> -->
                          </div>
                        </div>
                        <div v-else class="d-flex align-items-center">
                          <i class="fa fa-times text-danger mr-1"></i>
                          <!-- <div>
                            <span>
                              {{ $t('activity.lessonTimeActive') }} :
                              {{ calculateTime(item.start_date, item.end_date) }}
                            </span>
                          </div> -->
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'ActivityItem',
  filters: {
    timeInHours: function (date) {
      if (!date) return '';
      return moment(date).format('hh:mm:ss a');
    },
    elapsedSecondsInHours: function (value) {
      if (!value) return '00:00:00';
      let hours = parseInt(Math.floor(value / 3600));
      let minutes = parseInt(Math.floor((value - hours * 3600) / 60));
      let seconds = parseInt((value - (hours * 3600 + minutes * 60)) % 60);

      let dHours = hours > 9 ? hours : '0' + hours;
      let dMins = minutes > 9 ? minutes : '0' + minutes;
      let dSecs = seconds > 9 ? seconds : '0' + seconds;

      return dHours + ':' + dMins + ':' + dSecs;
    },
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activities: [],
      show: false,
      studyTime: 0,
    };
  },
  computed: {
    calculateTotalTime: function () {
      let durations = [];
      this.group.items.forEach(item => {
        let end = moment(item.end_date);
        let startDate = moment(item.start_date);
        var duration = end.diff(startDate);
        durations.push(moment.utc(duration).format('HH:mm:ss'));
      });

      const totalDurations = durations
        .slice(1)
        .reduce((prev, cur) => moment.duration(cur).add(prev), moment.duration(durations[0]));
      let totalTime = moment.utc(totalDurations.asMilliseconds()).format('HH:mm:ss');
      return totalTime;
    },
  },
  watch: {
    group: function () {
      this.onFetchActivities();
    },
  },
  created() {
    this.onFetchActivities();
  },
  methods: {
    calculateTime: function (startDate, endDate) {
      let _endDate = moment(endDate);
      let _startDate = moment(startDate);
      var duration = _endDate.diff(_startDate);

      let time = moment.utc(duration).format('HH:mm:ss');
      return time;
    },
    onFetchActivities() {
      // this.fetchActivities({
      //   term: 'search',
      //   filters: {
      //     session_id: this.session.id,
      //   },
      // }).then(res => {
      //   this.activities = res.data.items;
      //   this.studyTime = this.activities[0].time_active;
      // });
    },
    ...mapActions({
      fetchActivities: 'activity/FETCH_LIST',
    }),
  },
};
</script>
<style lang="sass" scoped>
.show
  padding: .5em
  cursor: pointer

.component-fade-enter-active, .component-fade-leave-active
  transition: opacity .3s ease

.component-fade-enter, .component-fade-leave-to
  opacity: 0

.card-header
  padding: .5em
  +forDesktop
    padding: 20px
</style>
